export const bidAdjustmentFieldStyle = { minWidth: '250px', flex: 1 };
export const bidAdjustmentFieldStyleHalf = { minWidth: '250px', flex: 0.5 };
export const bidAdjustmentValueFieldStyle = { minWidth: '88px' };
